const NOINDEX_PATHS = Object.freeze([
  '/admin',
  '/configure',
  '/login',
  '/myalerts',
  '/subscribe',
  '/user',
  '/user/action',
  '/user/subscription',
])

function isNoindexPath(pathname) {
  if (!pathname) return false
  const path =
    pathname !== '/' && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname
  return NOINDEX_PATHS.includes(path)
}

module.exports = { NOINDEX_PATHS, isNoindexPath }
